export let formValues = {};

export class Form {
    constructor(form) {
        this.form = form;
        this.inputFields = this.form.querySelectorAll(".form-input");
        this.submitButton = this.form.querySelector(".button");
        this.addMaterialAnimations();
    }

    // form animations
    addMaterialAnimations() {
        for (let i = 0; i < this.inputFields.length; i++) {
            this.onFocus(this.inputFields[i]);
            this.onBlur(this.inputFields[i]);
            this.onKeyStroke(this.inputFields[i]);
        }
    }

    // clicking on an input field
    onFocus(selector) {
        selector.addEventListener("focus", () => {
            selector.parentElement.classList.add("focused");
        });
    }

    // clicking off an input field
    onBlur(selector) {
        selector.addEventListener("blur", () => {
            if (selector.value === "") {
                selector.classList.remove("filled");
                selector.parentElement.classList.remove("focused");
                selector.parentElement.classList.add("invalid");
            } else {
                this.markFieldValid(selector);
            }
        });
    }

    // makes valid or invaid based on input requirements 
    markFieldValid(selector) {
        selector.parentElement.classList.add("focused");
        selector.classList.add("filled");
        selector.parentElement.classList.remove("invalid");
        this.checkFormValid(this);
    }

    // checks if form is valid after every keystroke
    onKeyStroke(selector) {
        let self = this;

        if (selector.id !== "geolocation") {
            selector.addEventListener("keyup", e => {
                if (e.key !== "Tab") {
                    this.checkFormValid(self);
                }
            });
        }
    }

    // validity of form
    checkFormValid(self) {
        // bypass forms with radio buttons
        if (!self.form.classList.contains('gender-form') && 
            !self.form.classList.contains('ethnicity-form') && 
            !self.form.classList.contains('connection-form') &&
            !self.form.classList.contains('facility-form'))
            {
            if (self.form.checkValidity()) {
                self.submitButton.classList.remove("disabled");
            } else {
                self.submitButton.classList.add("disabled");
            }
        }
    }
}
